import { EventSlot } from '../events/EventSlot';
import { Vector, Vector2 } from 'three';
import { DOMHitTest } from "./DOMHitTest";

export class KeyInfo
{
  key:string;
  timeDown:number;
}

export type ModifierKey = "Alt" | "Control" | "Shift" | "Meta" ;

export class InputManager
{
  _codesHold = new Map<string,string>(); 
  private _altDown = false;
  get altDown(){return this._altDown; }
  private _controlDown = false;
  get controlDown(){return this._controlDown; }
  private _shiftDown = false;
  get shiftDown(){return this._shiftDown; }


  _metaDown = false;

  onKey = new EventSlot<KeyboardEvent>();

  constructor()
  {
    this._initialize();
  }

  private _initialize()
  {
    document.addEventListener( "keydown", ( e ) => this.onKeyDown( e ) );
    document.addEventListener( "keypress", ( e ) => this.onKeyPress( e ));
    document.addEventListener( "keyup", ( e ) => this.onKeyUp( e ) );

    document.addEventListener( "mousemove",       
      ( e ) =>
      {
        this._mousePosition.set( e.pageX, e.pageY );
      }

    )
  }   



  private _mousePosition = new Vector2( 0, 0 );
  get mousePosition(){ return this._mousePosition.clone(); }

  isHovered( e:Element )
  {
    let box = DOMHitTest.getPageBox( e );   
    let isHovered = box.containsPoint( this.mousePosition );
    return isHovered;
  }
  
  toKeyString( e:KeyboardEvent )
  {
    let key = e.key;

    if ( /^(Alt|Control|Shift|Meta)$/.test( key ) )
    {
      return key;
    }

    let modifiers = [];
    
    if ( e.altKey ) 
    {
      modifiers.push( "Alt" );
    }  

    if ( e.ctrlKey )
    {
      modifiers.push( "Control" );
    }

    if ( e.shiftKey )
    {
      modifiers.push( "Shift" );
    }

    if ( modifiers.length === 0 )
    {
      return key;
    }

    return modifiers.join( " " ) + " " + key;

  }

  isKeyHold( holdKeyString:string )
  {
    let keyCodes = this._codesHold.keys();
    
    for ( let keyCode of keyCodes )
    {
      let keyString = this._codesHold.get( keyCode );

      if ( keyString === holdKeyString )
      {
        return true;
      }
    }

    return false;
    
  }

  
  _udpateModifierKeys( e:KeyboardEvent)
  {
    this._altDown = e.altKey;
    this._controlDown = e.ctrlKey;
    this._shiftDown = e.shiftKey;
    this._metaDown = e.metaKey;
  }

  onKeyDown( e:KeyboardEvent )
  {
    //console.log( "DOWN", e.code, e );

    this._codesHold.set( e.code, this.toKeyString( e ) );
    this._udpateModifierKeys( e );

    this.onKey.dispatch( e );
  } 

  onKeyPress( e:KeyboardEvent )
  {
    //console.log( "PRESS", e.code, e );

    let keyString = this.toKeyString( e );
    let changed = this._codesHold.get( e.code ) !== keyString;
    this._codesHold.set( e.code, keyString ); 
    this._udpateModifierKeys( e );    

    if ( changed )
    {
      this.onKey.dispatch( e );
    }    
  }

  onKeyUp( e:KeyboardEvent )
  {
    this._codesHold.delete( e.code );
    this._udpateModifierKeys( e );
  }

  
}